import React from "react"
import { Route } from "react-router-dom"
import BreadcrumbsItem from "./BreadcrumbItem"

const Breadcrumb = () => <Route component={BreadcrumbsItem} />

export default Breadcrumb
